export const parrotDarkBlue = "#003366";
export const parrotDarkerBlue = "#011a32";
export const parrotTextDarkBlue = "#00008B";
export const parrotButtonDarkBlue = "#005187";
export const parrotBlue = "rgb(10, 119, 234)";
export const parrotBlueTransparent = "rgba(0, 119, 234, 0.06)";
export const parrotBlueSemiTransparent = "rgba(0, 119, 234, 0.2)";
export const parrotBlueDarkTransparent = "rgba(0, 119, 234, 0.3)";
export const parrotBlueDarkTransparent2 = "rgba(0, 119, 234, 0.5)";
export const parrotGreen = "rgb(42, 200, 152)";
export const parrotButtonGreen = "#004422";
export const parrotGreenTransparent = "rgba(42, 200, 152, 0.06)";
export const parrotGreyTransparent = "rgb(246, 246, 246)";
export const parrotRed = "#CB0404";
export const parrotPlaceholderGrey = "#a3b4c5";
export const parrotLightBlue = "#3c9dde";
export const parrotPistachioGreen = "#9Bd35A"
export const parrotBananaLeafGreen = "#689F38";
export const parrotCream = "#f9f5f1";
export const parrotYellow = "#FFB800";

export const parrotBoatPurple = "#3b2697";
export const parrotCarRed = "#D53E4F";
export const parrotCaravanOrangeRed = "#F46D43";
export const parrotBusYellowGreen = "#E6F598";
export const parrotWalkTurquoise = "#06B6D4";
export const parrotRunLightOrange = "#FDAE61";
export const parrotMotorcycleDarkRed = "#9E0142";
export const parrotBicycleTealGreen = "#66C2A5";
export const parrotTinyHouseLightYellow = "#FEE08B";
export const parrotAirplaneLightGreen = "#ABDDA4";
export const parrotTrainPink = "#F781BF";

export const vehicleColors = {
  0: "#3b2697",
  1: "#D53E4F",
  2: "#F46D43",
  3: "#E6F598",
  4: "#06B6D4",
  5: "#FDAE61",
  6: "#9E0142",
  7: "#66C2A5",
  8: "#FEE08B",
  9: "#ABDDA4",
  10: "#F781BF",
};